import { AccountingAuditModel } from '../models';

export interface AccountingAuditResponse {
	status: boolean;
	audit: AccountingAuditModel;
}

export interface AccountingAuditsResponse {
	status: boolean;
	audits: AccountingAuditModel[];
}
